module.exports = __webpack_public_path__ + "static/media/info_demo1.c9e57bb4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_demo1.gif
// module id = 803
// module chunks = 0